module.exports = __webpack_public_path__ + "img/phone.6464c354.svg";